export default __webpack_public_path__ + "locales/ar-SA/Settings.json?hash=3f804da277d317ba7cd7dd105cf04bd8";